<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    <mask id="a" maskUnits="userSpaceOnUse" mask-type="alpha">
      <path
        stroke="currentColor"
        fill="transparent"
        stroke-width="3.2"
        d="M7.898 0v10.165M.102 5.44c3.029.188 9.98 2.41 13.553 9.788"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        stroke-width="3.2"
        d="M15.898 5.44c-3.029.188-9.98 2.41-13.552 9.788"
      />
    </mask>
    <g mask="url(#a)">
      <path d="M0 0h8v16H0z" />
    </g>
  </svg>
</template>
